import type { Props } from '@service-victoria/component-library/components/AddressLookup';
import SingleAddressLookup from '@service-victoria/component-library/components/AddressLookup/Single';
import React from 'react';

import { addressService } from 'app/services';
import { constants, url } from 'app/utils';

type ComponentProps = {
  fieldName: string;
  label: string;
  transactionType: string;
  onSelection?: (address: Props.Interfaces.ApiFullAddress) => void;
};

const baseURL = url.getSearchApiDomain();

const AddressLookup: React.FC<ComponentProps> = ({
  fieldName,
  label,
  transactionType,
  onSelection
}) => {
  const loadOptions = addressService.getAddressesLookup(baseURL, transactionType);
  const loadAddressFullDetailsHandler = addressService.getAddressDetails(baseURL, transactionType);

  const singleProps: Omit<
    Props.Single,
    'hint' | 'aria-label' | 'minLength' | 'cacheOptions' | 'defaultOptions'
  > = {
    fieldName,
    label,
    allowManualAddressEntry: true,
    displayPOBox: true,
    isClearable: true,
    loadOptions,
    notFoundAddress: () => " Can't find a matching address",
    fullFormProps: {
      stateProps: {
        options: constants.ALLOWED_STATES.map(state => {
          return { label: state, value: state };
        })
      }
    },
    loadAddressFullDetailsHandler: async (addressId: string) => {
      const result = await loadAddressFullDetailsHandler(addressId);

      if (onSelection) {
        // Note - this needs to be wrapped in a setTimeout because the component lib is blowing out the actions of setFieldValue
        setTimeout(() => {
          onSelection(result);
        }, 0);
      }
      return result;
    },
    debounceOptions: {
      enabled: true,
      timeout: 500
    }
  };
  return <SingleAddressLookup {...(singleProps as Props.Single)} />;
};

export default AddressLookup;
